import {useEffect, useState} from 'react'
import Headline4 from "../../../../components/headings/Headline4";
import Headline5 from "../../../../components/headings/Headline5";
import Styles from "../../styles.module.scss";
import SideMenu from '../../sideMenu';
import { makeSideBarActive } from '../../../../utils/EllowUtils';
import * as CONSTANTS from '../../../../utils/CONSTANTS';
import {useLocation} from 'react-router-dom';
import {toWords} from 'number-to-words'
import devIcon from "../../../../assets/images/dev-icon.png"; 
import { getAPI, postAPI } from "../../../../api/apis";
import NotificationAlert from '../../../../components/notification';
import TestModal from '../../../../modals/testModal';
import DOMPurify from "dompurify";
import { convertToHTML } from "draft-convert";
import { convertFromRaw } from "draft-js";
import  mixpanelData, { viewedpageMixpanel } from '../../../../utils/mixpanel';
import DashboardHeader from '../../dashboardHeader';
import { REACT_APP_CANDIDATE_FREELANCER , REACT_APP_PROFILE } from '../../../../utils/common';

 

function JobDetails(props : any) {
    
    
    const location= useLocation()
    const job: any = location.state ? location.state : null

    const jobId:string = job[5].jobId
    const menu = makeSideBarActive(CONSTANTS.sideMenuFreelancer, 4)

    const profileMetadata = JSON.parse(localStorage.getItem("profile_metadata") || "") || {}
    const loginId: string = localStorage.getItem('loginId') || ''
    // const [selected, setSelected] = useState<number>(0);

    const [visibleTestModal, setVisibleTestModal] = useState(true);
    const [test_id, setTest_id] = useState<number>()
    const [testName, setTestName] = useState<string>()
    const [alert, setAlert] = useState<boolean>(false)
    const [message, setMessage] = useState<string>('')
    const [testDetails, setTestDetails] = useState<any>()
    const [jobRole, setJobRole] = useState<any>()
    // const [jobDescription, setJobDescription] = useState<any>()
    const [jobRequirements, setJobRequirements] = useState<any>()
    const [jobResponsiblities, setJobResponsiblities] = useState<any>()
    //  const navigate = useNavigate()
    const [coreSkills, setCoreSkills] = useState<any>()
     useEffect(() => {
       viewedpageMixpanel()
     }, [])  
  
  

     useEffect(() => {  
      getAPI( REACT_APP_CANDIDATE_FREELANCER + `/test-details/${jobId}?loginId=${loginId}`).then((response: any) =>
      { 
        if (response && response.status ===  1) {
          setTestDetails(response.data[0].test_details)
          setJobRole(response.data[0].job_metadata.title)
          // setJobDescription(response.data[0].job_metadata.jobDescription)
          setJobRequirements(response.data[0].job_metadata.jobRequirements)
          setJobResponsiblities(response.data[0].job_metadata.jobResponsibilities)
          viewdJobs()

        }
      }

      )
     // eslint-disable-next-line react-hooks/exhaustive-deps
     }, [])
  
     const viewdJobs = (): void => {
      mixpanelData('New MWP - Job Viewed', {
        'distinct_id': profileMetadata && profileMetadata.email,
        'Candidate loginid': loginId,
        'Canidate email': profileMetadata && profileMetadata.email,
        'Job role': profileMetadata && profileMetadata.jobRoles &&  profileMetadata.jobRoles.map((item: any) => {return(item.name)}),
        'Skills': profileMetadata && profileMetadata.techStack && profileMetadata.techStack.length > 0 && profileMetadata.techStack.map((item: any) => { return item.skill.skillName }),
        'Job id': jobId,
        'Job Role': jobRole
      })
    }
     

     const takeTest = (item : any) => {

        let value = {
          loginId: loginId,
          email: profileMetadata.email,
          redirectionUrl: 'https://myworkplace.ellow.io/assessments',
          testId: test_id,
          candidateName: profileMetadata.firstName +' '+profileMetadata.lastName
        }
        postAPI( REACT_APP_PROFILE + '/test-invite-ext', value).then((response) => {
          if ( response && response.status === 1){
            mixpanelData('MWP-Test Details Updated', {
              'source': "freelancer test details updated",
              'Success':  true,
              'distinct_id': value && value.email,
              'Name' : value.candidateName,
              'testId': value.testId,
              'testName': testName,
              'Email':value.email,
            })
            mixpanelData('Test -Take test', {
              'distinct_id': value && value.email,
              'Candidate loginid': loginId,
              'Test id': value.testId,
              'Test name': testName,
              'Test link':  response.testUrl,
              'Email':value.email,
              "Name": profileMetadata.firstName +' '+profileMetadata.lastName
            })
            window.location.href = response.testUrl
          }else{
            setAlert(true)
            setMessage('Candidate(s) previously invited.')
            setTimeout(() => {
              setAlert(false)
            }, 4000);
            
          }
        })
      }
      const alertOnclose = () => {
        setAlert(false);
      }

      const pendingTest = (item: any) => {
        window.location.href = item.test_result.test_invite_url 
      }

      const createMarkup = (html: any) => {
        if (html.includes('{"blocks')) {
          let oldblockconverteddata = convertFromRaw(JSON.parse(html));
          let oldblockdataconvertedhtml = convertToHTML(oldblockconverteddata);
    
          html = JSON.stringify(oldblockdataconvertedhtml);
          return {
            __html: DOMPurify.sanitize(html).replace(/"/g, ''),
          };
        }
        if (html.includes("<p>") || html.includes("<ol") || html.includes("<ul>")) {
          return {
            __html: DOMPurify.sanitize(JSON.parse(html)).replace(/"/g, ''),
          };
        } else {
          html = "<p>" + html + "</p>";
          return {
            __html: DOMPurify.sanitize(html).replace(/"/g, ''),
          };
        }
      }

      const testResultPublished = (item: any) => {
        setAlert(true)
        if(item.test_result.invitation_metadata.is_passed ){
          setMessage('Hey, you made it! Our recruiters will get in touch with you soon to know your preferences so that they can get you matched to the most exciting and relevant job opportunities for you!')
        }else{
          setMessage('Hey, do not worry about failure; failures are the stepping stones for a huge success, so do not worry if you fail in the first attempt, you will have another chance to attempt the test after 3 months')
        }
        setTimeout(() => {
          setAlert(false)
        }, 5000);
      }
   
      const testModal = (item : any) => {
        setTest_id(item.test_id)
        setTestName(item.test_name)
        setVisibleTestModal(!visibleTestModal)
      }
      const closeTestModal = () => {
        setVisibleTestModal(!visibleTestModal)
  }
  
  const redirectToAvailability = () => {
    // setSelected(2)
  }

  return (
    <section className={Styles.dashboardWrapper}>
        {alert && <NotificationAlert closable={true} onClose={alertOnclose}>{message}</NotificationAlert> }
        {!visibleTestModal && ( <TestModal onClose={closeTestModal} takeTest={takeTest}/> )}
    <SideMenu menu={menu} />
      <div className={Styles.dashboardContent}>
      <DashboardHeader redirectToAvailability={redirectToAvailability} title={jobRole}/>
      <div className='contentBox'>
    <div className="innerPadd48">
        <div className={Styles.jobDetails}> 
            <Headline4> {jobRole} </Headline4>
            
             <div className={Styles.skillsHead}>
                <Headline5>Required skills</Headline5>
                {testDetails && testDetails.length > 0 && <p> {testDetails && toWords(testDetails.length).charAt(0).toUpperCase() + toWords(testDetails.length).slice(1)} more tests to go!</p>}
              </div>
            <div className={Styles.skillsCards}>
            {testDetails && testDetails.length > 0 ? testDetails.map((item:any,key:number) =>
                
                <div className={Styles.card}>
                    { item.skill.icon_url ? <img src={ item.skill.icon_url} alt='icon'/> : <img src={devIcon} alt='icon'/>}
                    <h3>{item.test_name}</h3>
                    <p>{Math.floor(item.duration) /60} mins</p>
                    <button onClick={(e: any) => item.test_result ? item.test_result.is_passed === null ? pendingTest(item) : testResultPublished(item) : testModal(item)}>
                        {item.test_result ? item.test_result.is_passed  ? 'Passed' : 'Pending' : 'Take Test'} 
                    </button>
                </div>
                ) : 
                coreSkills && coreSkills.map((item: any) => <div className={Styles.card}>
                    { item.skill && item.skill.icon_url ? <img src={ item.skill.icon_url}/> : <img src={devIcon}/>}
                    <h3>{item.skillName}</h3>
                    {/* <p>{Math.floor(item.duration) /60} mins</p> */}
                   {/* <button onClick={() => console.log('')}>
                        {item.test_result ? item.test_result.is_passed  ? 'Passed' : 'Pending' : 'Take Test'} 
                    </button> */}
                </div>) }            
            </div>
             <div>
              <Headline5>About the role</Headline5>
              {/* <p className='mb-40'>{jobDescription && jobDescription.split('\n').map((item :any ,i : any) => <p key = {i}>{item}</p>)}</p> */}
              <div className="preview" dangerouslySetInnerHTML={createMarkup(`We are looking for a ${jobRole}. The Candidate will be reporting directly to team leaders and will be working with cutting-edge technologies on world-class cloud platforms. The company helps businesses to experience noticeable growth by utilizing the tools, tech, and team that help boost ​ROI. This will be a long-term position for developers to experience rapid career growth.`)} ></div> 
            </div>
            {jobResponsiblities && <div>
              <Headline5>Job Responsibilities</Headline5>
              <ul className="listStyle">
                {/* <p className='mb-40'>{jobResponsiblities && jobResponsiblities.split('\n').map((item :any ,i : any) => <p key = {i}>{item}</p>)}</p> */}
                <div className="preview" dangerouslySetInnerHTML={createMarkup(jobResponsiblities)} ></div> 
              </ul>
            </div>}
            {jobRequirements && <div>
              <Headline5>Requirements</Headline5>
              {/* <p className='mb-40'>{jobRequirements && jobRequirements.split('\n').map((item :any ,i : any) => <p key = {i}>{item}</p>)}</p> */}
              <div className="preview" dangerouslySetInnerHTML={createMarkup(jobRequirements)} ></div> 
            </div>}
        </div>
        </div>
    </div>
    </div>
        </section>
    )
}

export default JobDetails